module.exports = {
  DISCONNECTED: 'disconnected',
  IN_PROGRESS: 'in-progress',
  FAILURE: 'failure',
  STOPPED: 'stopped',
  FINISHED: 'finished',
};
